module.exports = __webpack_public_path__ + "static/promo-c0bc211938ed2c54be8d583857341a24.png";